// Fix the confict suggestion search in Debut theme
if (typeof theme !== "undefined" && theme.hasOwnProperty("settings"))
  theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    // Optional
    loadProductFirst: true,
    styleScrollToTop: "style2",
    defaultDisplay: boostPFSThemeConfig.custom.layout,
    showPlaceholderProductList: true,
  },
};

(function () {
  BoostPFS.inject(this);

  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data["variants"][0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i];
          break;
        }
      }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add a specific class for grid item
    var itemGridWidthClass = "";
    var imageSize = "600x600";

    switch (boostPFSConfig.custom.products_per_row) {
      case 2:
        itemGridWidthClass = "medium-up--one-half";
        imageSize = "540x600";
        break;
      case 3:
        itemGridWidthClass = "small--one-half medium-up--one-third";
        imageSize = "345x550";
        break;
      case 4:
        itemGridWidthClass = "small--one-half medium-up--one-quarter";
        imageSize = "250x";
        break;
      case 5:
        itemGridWidthClass = "small--one-half medium-up--one-fifth";
        imageSize = "195x";
        break;
    }
    itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

    // Add soldOut class
    var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : "";
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add soldOut label
    var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : "";
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

    // Add Images — match product-card.liquid / image-ratio structure
    var itemImagesHtml = '';

    // Flip image (hover) — only when product has 2+ images
    if (images.length > 1) {
      var flipImageSrc = Utils.optimizeImage(images[1]["src"], "800x800_crop_center");
      itemImagesHtml +=
        '<img class="flip_image lazyload" ' +
        'src="' + flipImageSrc + '" ' +
        'data-src="' + flipImageSrc + '" ' +
        'alt="{{itemTitle}}">';
    }

    // Main image using the same aspect-ratio-square structure as product-card.liquid
    var mainImageSrc = images.length > 0
      ? Utils.optimizeImage(images[0]["src"], "800x800_crop_center")
      : boostPFSAppConfig.general.no_image_url;

    itemImagesHtml +=
      '<div class="relative w-full main_image">' +
        '<div class="aspect-ratio-square"></div>' +
        '<img src="' + mainImageSrc + '" ' +
          'class="absolute left-0 top-0 w-full h-full object-cover lazyload" ' +
          'alt="{{itemTitle}}">' +
      '</div>';

    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable
      ? boostPFSTemplate.vendorGridHtml
      : "";
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    var itemPriceHtml = buildPrice(data, onSale, priceVaries);

    console.log(itemPriceHtml);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Description
    var itemDescription = "";
    if (data.metafields.length > 0) {
      for (var i = 0; i < data.metafields.length; i++) {
        if (data.metafields[i].key == "short_description") {
          itemDescription =
            '<p class="product-card__description">' +
            data.metafields[i].value +
            "</p>";
        }
      }
    }
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

    // Add Reviews
    if (
      typeof Integration === "undefined" ||
      !Integration.hascompileTemplate("reviews")
    ) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, "");
    }

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrl(data),
    );

    return itemHtml;
  };

  ProductListItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data["variants"][0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i];
          break;
        }
      }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = boostPFSTemplate.productListItemHtml;

    // Add onSale label
    var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : "";
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

    // Add soldOut label
    var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : "";
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

    // Add Thumbnail
    var itemThumbUrl =
      images.length > 0
        ? Utils.optimizeImage(images[0]["src"], "600x600")
        : boostPFSConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Vendor
    var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable
      ? boostPFSTemplate.vendorSmallListHtml
      : "";
    itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
    var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable
      ? boostPFSTemplate.vendorMediumListHtml
      : "";
    itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

    // Add Price
    var itemPriceHtml = buildPrice(data, onSale, priceVaries);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Reviews
    if (
      typeof Integration === "undefined" ||
      !Integration.hascompileTemplate("reviews")
    ) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, "");
    }

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrl(data),
    );

    return itemHtml;
  };

  // Build Image style
  function buildImageStyle(data) {
    var images = data.images_info;
    var imgId = "ProductCardImage-" + data.id;
    var wrapperId = "ProductCardImageWrapper-" + data.id;
    var imageStyle = "";
    if (images.length > 0) {
      var image = images[0];
      var width = boostPFSConfig.custom.max_height;
      var height = boostPFSConfig.custom.max_height;
      var aspect_ratio = image.width / image.height;
      var small_style = true;
      var container_aspect_ratio = (width * 1.0) / height;

      if (image.aspect_ratio < 1.0) {
        var maximum_width = height * aspect_ratio;
        if (image.height <= height) {
          var maximum_height = image.height;
          maximum_width = image.width;
        } else {
          var maximum_height = height;
        }
      } else if (aspect_ratio < container_aspect_ratio) {
        var maximum_height = height / aspect_ratio;
        if (image.height <= height) {
          var maximum_height = image.height;
          var maximum_width = image.width;
        } else {
          var maximum_height = height;
          var maximum_width = height * aspect_ratio;
        }
      } else {
        var maximum_height = height / aspect_ratio;
        if (image.width <= width) {
          maximum_height = image.height;
          var maximum_width = image.width;
        } else {
          var maximum_width = width;
          maximum_height = maximum_width / aspect_ratio;
        }
      }

      imageStyle += "<style>";
      if (small_style) imageStyle += "@media screen and (min-width: 750px) {";
      imageStyle +=
        "#" +
        imgId +
        " {" +
        "max-width: " +
        maximum_width +
        "px;" +
        "max-height: " +
        maximum_height +
        "px;" +
        "}" +
        "#" +
        wrapperId +
        " {" +
        "max-width: " +
        maximum_width +
        "px;" +
        "max-height: " +
        maximum_height +
        "px;" +
        "}";
      if (small_style) imageStyle += "}";

      if (small_style) {
        if (aspect_ratio < 1) {
          maximum_width = 750 * aspect_ratio;
        } else {
          if (image.width < 750) {
            maximum_width = image.width;
          } else {
            maximum_width = 750;
          }
        }
        imageStyle += "@media screen and (max-width: 749px) {";
        imageStyle +=
          "#" +
          imgId +
          " {" +
          "max-width: " +
          maximum_width +
          "px;" +
          "max-height: 750px;" +
          "}" +
          "#" +
          wrapperId +
          " {" +
          "max-width: " +
          maximum_width +
          "px;" +
          "}";
        imageStyle += "}";
      }
      imageStyle += "</style>";
    }
    return imageStyle;
  }

  function buildPrice(data, onSale, priceVaries) {
    var moneyVat = window.theme.money_vat
      ? '<small class="text-xxxs pl-0-2 pt-0-4">ex. VAT</small>'
      : "";
    var priceHtml = "",
      onSaleClass = onSale ? " price--on-sale" : "";
    var soldOutClass = data.available ? "" : " price--sold-out";
    var comparePriceVaries =
      data.compare_at_price_min != data.compare_at_price_max;
    var priceVariesClass =
        !priceVaries && comparePriceVaries
          ? " price--compare-price-hidden"
          : "",
      variant = data.variants[0],
      unitPriceMeasurementClass = "",
      unitPriceSeparatorHtml = "",
      unitPirceBaseUnitHtml = "";

    if (variant.hasOwnProperty("unit_price_measurement")) {
      unitPriceMeasurementClass = " price--unit-available";
    }

    priceHtml += '<p class="product-card__price" data-price>';
    // if (boostPFSConfig.custom.hasOwnProperty('vendor_enable') && boostPFSConfig.custom.vendor_enable == true) {
    // 	priceHtml += '<div class="price__vendor price__vendor--listing"><dt>';
    // 	priceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.vendor + '</span>';
    // 	priceHtml += '</dt><dd>';
    // 	priceHtml += data.vendor;
    // 	priceHtml += '</dd></div>';
    // }

    priceHtml += '<div class="price__regular flex justify-center">';
    // priceHtml += '<dt><span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span></dt>';
    priceHtml += "<dd>";
    priceHtml +=
      '<span class="price-item price-item--regular" data-regular-price>';
    var priceTax = window.theme.product_tax
      ? ((data.price_min * window.theme.product_tax) / 5) * 5
      : data.price_min;

    if (priceVaries) {
      console.log(boostPFSConfig.label.from_lowest_price_html);
      priceHtml += boostPFSConfig.label.from_lowest_price_html.replace(
        /{{ lowest_price }}/,
        Utils.formatMoney(priceTax, theme.moneyWithFormat),
      );
    } else {
      priceHtml += Utils.formatMoney(priceTax, theme.moneyWithFormat);
    }
    priceHtml += "</span></dd>";

    priceHtml += moneyVat + "</div>";
    priceHtml += '<div class="price__sale">';

    // priceHtml += ' <dt> <span class="visually-hidden visually-hidden--inline">';
    // priceHtml += boostPFSConfig.label.sale_price +
    // 	'</span></dt>';
    priceHtml += '<dd> <span class="price-item price-item--sale">';
    if (priceVaries) {
      priceHtml += boostPFSConfig.label.from_lowest_price_html.replace(
        /{{ lowest_price }}/,
        Utils.formatMoney(priceTax, theme.moneyWithFormat),
      );
    } else {
      priceHtml += Utils.formatMoney(priceTax, theme.moneyWithFormat);
    }
    priceHtml += "</span></dd>";
    priceHtml += '<div class="price__compare">';
    //priceHtml += boostPFSConfig.label.regular_price;
    priceHtml += '<dd> <s class="price-item price-item--regular">';
    var compareAtPriceTax = window.theme.product_tax
      ? ((data.compare_at_price_min * window.theme.product_tax) / 5) * 5
      : data.compare_at_price_min;
    priceHtml += Utils.formatMoney(compareAtPriceTax, theme.moneyWithFormat);
    priceHtml += "</s></dd>";
    priceHtml += "</div>";
    priceHtml += "</div>";

    priceHtml +=
      '<div class="price__unit"> <dt> <span class="visually-hidden visually-hidden--inline">';
    //priceHtml += boostPFSConfig.label.unit_price_label;
    priceHtml += "</span></dt>";
    priceHtml += '<dd class="price-unit-price">';

    // unitPriceSeparatorHtml += '<span aria-hidden="true">/</span><span class="visually-hidden">';
    // unitPriceSeparatorHtml += boostPFSConfig.label.unit_price_separator + '&nbsp;</span>';

    if (
      variant.hasOwnProperty("unit_price_measurement") &&
      variant.unit_price_measurement
    ) {
      unitPirceBaseUnitHtml += "<span>";
      if (
        variant.hasOwnProperty("reference_value") &&
        variant.unit_price_measurement.reference_value != 1
      ) {
        unitPirceBaseUnitHtml += variant.unit_price_measurement.reference_value;
      }
      if (variant.hasOwnProperty("reference_unit")) {
        unitPirceBaseUnitHtml += variant.unit_price_measurement.reference_unit;
      }
      unitPirceBaseUnitHtml += "</span>";
    }

    if (variant.hasOwnProperty("unit_price")) {
      priceHtml +=
        "<span>" +
        Utils.formatMoney(variant.unit_price, theme.moneyWithFormat) +
        "</span>";
    }
    priceHtml += unitPriceSeparatorHtml + unitPirceBaseUnitHtml;

    priceHtml += "</dd></div>";

    //priceHtml += '<div class="price__badges price__badges--listing">';
    //priceHtml += '<span class="price__badge price__badge--sale" aria-hidden="true"> <span>' + boostPFSConfig.label.sale + '</span></span>';
    //priceHtml += '<span class="price__badge price__badge--sold-out">' + boostPFSConfig.label.sold_out + '</span>';
    //'</span></div>';

    priceHtml += "</p>";

    return priceHtml;
  }

  /// Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return "";
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml =
      currentPage > 1
        ? boostPFSTemplate.previousActiveHtml
        : boostPFSTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage - 1),
    );
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml =
      currentPage < totalPage
        ? boostPFSTemplate.nextActiveHtml
        : boostPFSTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage + 1),
    );
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (
      var iBefore = currentPage - 1;
      iBefore > currentPage - 2 && iBefore > 0;
      iBefore--
    ) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 3 > 0) {
      beforeCurrentPageArr.unshift("...");
    }
    if (currentPage - 3 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (
      var iAfter = currentPage + 1;
      iAfter < currentPage + 2 && iAfter <= totalPage;
      iAfter++
    ) {
      if (currentPage + 2 <= totalPage) {
        if (iAfter != totalPage - 1) {
          afterCurrentPageArr.push(iAfter);
        }
      } else {
        afterCurrentPageArr.push(iAfter);
      }
    }
    if (currentPage + 2 < totalPage) {
      afterCurrentPageArr.push("...");
    }
    if (currentPage + 2 <= totalPage) {
      afterCurrentPageArr.push(totalPage - 1);
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = "";
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == "...") {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml +=
          pageArr[iPage] == currentPage
            ? boostPFSTemplate.pageItemSelectedHtml
            : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, pageArr[iPage]),
      );
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || "";
        // Build content
        var sortingItemsHtml = "";
        var sortingSelected = "";
        for (var k in sortingArr) {
          activeClass = "";
          if (paramSort == k) {
            activeClass = "boost-pfs-filter-sort-item-active";
            sortingSelected = sortingArr[k];
            console.log("Here" + sortingArr[k]);
            jQ("body").find("[data-sorting-selected]").text(sortingSelected);
          }
          sortingItemsHtml +=
            '<li><a href="#" data-sort="' +
            k +
            '" class="' +
            activeClass +
            '">' +
            sortingArr[k] +
            "</a></li>";
        }
        // for (var k in sortingArr) {
        // 	sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
        // 	sortingItemsHtmlLists += '<li><span></span><a href="#" data-sort="' + k + '">' + sortingArr[k] + '</a></li>';
        // }
        html = boostPFSTemplate.sortingHtml.replace(
          /{{sortingItems}}/g,
          sortingItemsHtml,
        );
        jQ("body").find("[data-sorting-selected]").text(sortingSelected);

        setTimeout(function () {
          if (sortingSelected != "") {
            jQ("body").find("[data-sorting-selected]").text(sortingSelected);
          } else {
            jQ("body").find("[data-sorting-selected]").text("sorting");
          }
        }, 500);
        // texthtml = boostPFSTemplate.sortingHtmlLists.replace(/{{sortingLists}}/g, sortingItemsHtmlLists);
      }
    }

    return html;
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    var _this = this;
    jQ(".boost-pfs-filter-filter-dropdown a").click(function (e) {
      e.preventDefault();
      FilterApi.setParam("sort", jQ(this).data("sort"));
      FilterApi.setParam("page", 1);
      FilterApi.applyFilter("sort");
    });

    jQ(".boost-pfs-filter-custom-sorting > button").click(function () {
      if (!jQ(".boost-pfs-filter-filter-dropdown").is(":animated")) {
        jQ(".boost-pfs-filter-filter-dropdown")
          .toggle()
          .parent()
          .toggleClass("boost-pfs-filter-sort-active");
      }
    });

    jQ(Selector.filterTreeMobileButton).click(function () {
      jQ(
        ".boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown",
      ).hide();
    });

    var labelSort = "";
    var paramSort = Globals.queryParams.sort || "";
    if (paramSort.length > 0) {
      var labelHandle = "sorting_" + paramSort.replace(/\-/g, "_");
      labelSort = Labels[labelHandle];
    } else {
      labelSort = Labels.sorting_heading;
    }
    jQ("body")
      .find(".boost-pfs-filter-custom-sorting button [data-sorting-selected]")
      .text(labelSort);
  };

  // Build Display type
  ProductDisplayType.prototype.compileTemplate = function () {
    var itemHtml = "<span>View As </span>";
    itemHtml +=
      '<a href="' +
      Utils.buildToolbarLink("display", "list", "grid") +
      '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
    itemHtml +=
      '<a href="' +
      Utils.buildToolbarLink("display", "grid", "list") +
      '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
    itemHtml = itemHtml.replace(
      /{{class.productDisplayType}}/g,
      Class.productDisplayType,
    );

    return itemHtml;
  };

  jQ("body").on("click", ".boost-pfs-filter-option-title", function () {
    var $this = jQ(this);
    $this.parent().toggleClass("boost-pfs-filter-close-options");
  });
  setTimeout(function () {
    jQ("body")
      .find(".boost-pfs-filter-option-swatch-image")
      .each(function (item) {
        jQ(this)
          .parent()
          .addClass(jQ(this).attr("title").replace(/\s+/g, "-").toLowerCase());
      });
    jQ("body")
      .find(".boost-pfs-filter-option-value")
      .each(function (item) {
        jQ(this).text(jQ(this).text().replace("-", " "));
      });
    if (jQ("body").find(".boost-pfs-filter-clear").length > 0) {
      jQ('[data-filter-wrapper="desktop"]').addClass("clear-filter");
    } else {
      jQ('[data-filter-wrapper="desktop"]').removeClass("clear-filter");
    }
  }, 500);

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;
    var productSelector = jQ(Selector.products);
    if (Globals.queryParams.display == "list") {
      if (productSelector.children(".list-view-items").length == 0) {
        productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
      }
      productSelector.removeClass("grid grid--uniform grid--view-items");
    } else {
      if (productSelector.children(".list-view-items").length > 0) {
        productSelector.children(".list-view-items").children().unwrap();
      }
      productSelector.addClass("grid grid--uniform grid--view-items");
    }

    setTimeout(function () {
      jQ("body")
        .find(".boost-pfs-filter-option-swatch-image")
        .each(function (item) {
          jQ(this)
            .parent()
            .addClass(
              jQ(this).attr("title").replace(/\s+/g, "-").toLowerCase(),
            );
        });
      jQ("body")
        .find(".boost-pfs-filter-option-value")
        .each(function (item) {
          jQ(this).text(jQ(this).text().replace("-", " "));
        });
      if (jQ("body").find(".boost-pfs-filter-clear").length > 0) {
        jQ('[data-filter-wrapper="desktop"]').addClass("clear-filter");
      } else {
        jQ('[data-filter-wrapper="desktop"]').removeClass("clear-filter");
      }
    }, 500);
    if (jQ("body").find(".boost-pfs-filter-clear").length > 0) {
      jQ('[data-filter-wrapper="desktop"]').addClass("clear-filter");
    } else {
      jQ('[data-filter-wrapper="desktop"]').removeClass("clear-filter");
    }
  };

  // Build Additional Elements
  FilterResult.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    var totalProduct = "";
    setTimeout(function () {
      jQ("body")
        .find(".boost-pfs-filter-option-swatch-image")
        .each(function (item) {
          jQ(this)
            .parent()
            .addClass(
              jQ(this).attr("title").replace(/\s+/g, "-").toLowerCase(),
            );
        });
      jQ("body")
        .find(".boost-pfs-filter-option-value")
        .each(function (item) {
          jQ(this).text(jQ(this).text().replace("-", " "));
        });
      if (jQ("body").find(".boost-pfs-filter-clear").length > 0) {
        jQ('[data-filter-wrapper="desktop"]').addClass("clear-filter");
      } else {
        jQ('[data-filter-wrapper="desktop"]').removeClass("clear-filter");
      }
    }, 500);
    if (data.total_product == 1) {
      totalProduct = boostPFSConfig.label.items_with_count_one.replace(
        /{{ count }}/g,
        data.total_product,
      );
      jQ(".filters-toolbar__product-count").text(
        data.total_product + " product",
      );
    } else {
      totalProduct = boostPFSConfig.label.items_with_count_other.replace(
        /{{ count }}/g,
        data.total_product,
      );
      jQ(".filters-toolbar__product-count").text(
        data.total_product + " products",
      );
    }
    jQ(".boost-pfs-filter-total-product").html(totalProduct);
  };
})();

// (function () {
//   const PAGE_SIZE = 24;
//   const TITLE_SPLIT = '(';

//   window.__SeenTitles = {}; // reset on each new load

//   // Ensure Boost fetches enough items
//   window.boostPFSFilterConfig = window.boostPFSFilterConfig || {};
//   window.boostPFSFilterConfig.general = window.boostPFSFilterConfig.general || {};
//   window.boostPFSFilterConfig.general.limit = 50; // fetch more than needed

//   function waitForBoost(retry = 0) {
//     if (typeof ProductList === 'undefined' || typeof jQ === 'undefined') {
//       if (retry > 20) return;
//       return setTimeout(() => waitForBoost(retry + 1), 100);
//     }

//     const oldAfterRender = ProductList.prototype.afterRender || function () {};

//     ProductList.prototype.afterRender = function () {
//       oldAfterRender.apply(this, arguments);

//       const $grid = this.$element || jQ('.boost-pfs-filter-products');
//       const seen = {};
//       let kept = 0;

//       $grid.find('.product-card').each(function () {
//         const $card = jQ(this);
//         const title = $card.find('.product-card__name').text();
//         const base = title.split(TITLE_SPLIT)[0].trim().toLowerCase();

//         if (seen[base]) {
//           $card.remove(); // remove duplicate
//         } else if (kept < PAGE_SIZE) {
//           seen[base] = true;
//           kept += 1;
//         } else {
//           $card.remove(); // trim extras beyond 24
//         }
//       });

//       // Update count
//       jQ('.filters-toolbar__product-count').text(
//         kept + (kept === 1 ? ' product' : ' products')
//       );
//     };
//   }

//   waitForBoost();
// })();


